// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1u-EW","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1EH6a","obliqueLine":"membershipbadge_obliqueLine__3vkEP"};